import logo from './logo.svg';
import './App.css';
import Nav from './Nav';
import Banner from './Banner';
import Row from './Row';
import requests from './requests';

function App() {
  return (
    <div className="app">
      <Nav />
      <Banner />
      <Row 
        title="NETFLIX ORIGINALS" 
        fetchURL={requests.fetchNetflixOriginals}
        isLargeRow
      />

      <Row 
        title="Trending" 
        fetchURL={requests.fetchTrending}
      />

      <Row 
        title="Top-rated" 
        fetchURL={requests.fetchTopRated}
      />

      <Row 
        title="Action movies" 
        fetchURL={requests.fetchActionMovies}
      />

      <Row 
        title="Comedy movies" 
        fetchURL={requests.fetchComedyMovies}
      />

      <Row 
        title="Romance movies" 
        fetchURL={requests.fetchRomanceMovies}
      />

      <Row 
        title="Documentaries" 
        fetchURL={requests.fetchDocumentaries}
      />

      <Row 
        title="Horror movies" 
        fetchURL={requests.fetchHorrorMovies}
      />
    </div>
  );
}

export default App;
